<div class="row">
    <div class="col-12" style="margin-top: 100px;">
    </div>
</div>

<div class="container-xl">
    <ng-container *ngIf="propertyList && propertyList.length > 0">
        <div class="header text-center">Favourite Properties</div>
        <ng-container *ngFor="let propertyData of propertyList">
            <app-common-property [propertyData]='propertyData'></app-common-property>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="!propertyList || propertyList.length == 0">
        <div class="container py-5">
            <div class="row">
                <div class="col-md-12">
                    <div class="card text-center">
                        <div class="card-body">
                            <i class="far fa-frown-open fa-4x"></i> <!-- FontAwesome icon -->
                            <h5 class="card-title mt-3">
                                No Favourite Property Found
                            </h5>
                            <p class="card-text">You haven't added any properties to your favourites yet. Start
                                exploring to find your dream property!</p>
                            <a href="/" class="btn btn-primary btn-theme">Browse Properties</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

</div>